<template>
  <div class="not-found-container">
    <h1 class="">404 Page Not Found!</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped>
.not-found-container {
  display: grid;
  height: 100vh;
  width: 100%;
  place-items: center;
}
</style>
